export function transformDateForSend (date) {
  if (!date) return {}

  const dates = date.split(' - ')
  return {
    date_start: dates[0],
    date_finish: dates[1] ? dates[1] : dates[0]
  }
}
